/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Branch2Icon = ({ width = 24, height = 24, hidden = false, title = 'Branch2' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M23.392 11.8a5.908 5.908 0 1 0-1.275-2.641l-9.623 4.903a6.016 6.016 0 0 0-.908-.846l-.007-.007a5.99 5.99 0 0 0-.99-.6c-.036-.017-.069-.04-.106-.057a5.962 5.962 0 0 0-.994-.343c-.073-.019-.14-.05-.214-.067a6 6 0 1 0 0 11.716c.074-.017.141-.048.214-.067a5.964 5.964 0 0 0 .994-.343c.037-.017.07-.04.107-.058a5.982 5.982 0 0 0 .989-.6l.007-.006a6.016 6.016 0 0 0 .908-.846l9.623 4.903a6.093 6.093 0 1 0 1.275-2.64l-9.552-4.868a5.62 5.62 0 0 0 0-2.665v-.001ZM28 5a3 3 0 1 1-3 3 3 3 0 0 1 3-3Zm0 20a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
    />
  </svg>`;
};
